import "../../node_modules/lottie-web/build/player/esm/lottie.min.js";

const $ = function(selector) {
    return document.getElementById(selector);
};
const $$ = function(selector) {
    return document.querySelectorAll(selector);
};

let $$HiddenInput = "";

var animation = bodymovin.loadAnimation({
    container: document.getElementById('stu'),
    renderer: 'svg',
    loop: false,
    autoplay: true,
    path: 'img/23-BE-9886 BE Holiday Card Marquee Animation_Test_V1.json'
});
  
window.addEventListener('message', event => {
    if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
        $$HiddenInput = $$("input[name='charity_survey']");
        $$SubmitButton = $$("input[type='submit']");
        $$SubmitButton[0].addEventListener("click", function(event) {
            //if competition code doesn't contain 2 letters and 4 numbers then stop the form from submitting...
            
            if ($$HiddenInput[0].value === "") {
                console.log("nope");
                event.preventDefault();
                window.alert("Please select a charity");
            }
        }, false);
    }
 });


window.addEventListener("DOMContentLoaded", (event) => {
    let charities = $$('div.charity');
    let modal = $('modal');
    $$('button').forEach((button) => { 
        button.addEventListener("click", (e) => {
            for (var i = 0; i < charities.length; i++) {
                charities[i].classList.remove('active');
                charities[i].classList.add('inactive');
            }
            const card = e.target.closest('.inactive')
            card.classList.remove('inactive');
            card.classList.add('active');
            $$HiddenInput[0].value = e.target.getAttribute('data-charity');
            window.location = '#vote';
        });
    });
    
});

